module.exports = __webpack_public_path__ + "images/d123cb25f20d425e1f73ba5cf015c5adac1ed64a838ce17bfd2f6673d7945a04.svg";